import { compactInputClass, ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import {
  LABOR_PAY_WEEKDAY_LABELS,
  laborPayCutoffFromHhmm,
  laborPayCutoffHhmm,
  type LaborPayCutoffConfig,
} from "@/lib/manufacturing/laborPayWeek";

export function ManufacturingLaborPayCutoffBar({
  cutoffLabel,
  config,
  canEdit,
  busy,
  onChange,
  onCloseWeek,
}: {
  cutoffLabel: string | null;
  config: LaborPayCutoffConfig | null;
  canEdit: boolean;
  busy: boolean;
  onChange: (next: LaborPayCutoffConfig) => void;
  onCloseWeek: () => void;
}) {
  const weekday = config?.weekday ?? 4;
  const hhmm = config ? laborPayCutoffHhmm(config) : "15:00";
  const zone = config?.timeZone ?? "America/New_York";

  return (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-2 rounded border border-gray-200 px-2 py-1.5 text-xs dark:border-zinc-700">
      <div className="flex min-w-0 flex-wrap items-center gap-2 text-gray-600 dark:text-zinc-300">
        {canEdit && config ? (
          <>
            <span className="shrink-0">Weekly cutoff</span>
            <select
              className={`${compactInputClass} w-auto py-1 text-xs`}
              value={weekday}
              disabled={busy}
              aria-label="Labor invoice cutoff weekday"
              onChange={(e) => onChange(laborPayCutoffFromHhmm(hhmm, Number(e.target.value), zone))}
            >
              {LABOR_PAY_WEEKDAY_LABELS.map((label, i) => (
                <option key={label} value={i}>
                  {label}
                </option>
              ))}
            </select>
            <input
              type="time"
              className={`${compactInputClass} w-auto py-1 text-xs`}
              value={hhmm}
              disabled={busy}
              aria-label="Labor invoice cutoff time"
              onChange={(e) => onChange(laborPayCutoffFromHhmm(e.target.value, weekday, zone))}
            />
            <span className="text-gray-500 dark:text-zinc-400">
              This week{cutoffLabel ? `: ${cutoffLabel}` : ""}
            </span>
          </>
        ) : (
          <span>
            This week cutoff{cutoffLabel ? `: ${cutoffLabel}` : " (Thursday 3pm default until ops sets it)"}
          </span>
        )}
      </div>
      {canEdit ? (
        <button type="button" className={ghostBtnClass} disabled={busy} onClick={onCloseWeek}>
          Close week’s payout
        </button>
      ) : null}
    </div>
  );
}
